export function getPathsOfValue<T = any>(obj: any | undefined, valueTest: (value: T) => boolean) {
  const paths: string[][] = [];

  if (!(obj?.constructor === Object || obj?.constructor === Array)) {
    return paths;
  }

  function search(haystack: any, currentPath: string[] = []) {
    const path: string[] = currentPath;
    for (const key in haystack) {
      path.push(key);
      if (valueTest(haystack[key])) {
        paths.push([...path]);
      }

      if (haystack[key] && (haystack[key].constructor === Object || haystack[key].constructor === Array)) {
        search(haystack[key], [...path]);
      }
      path.pop();
    }
  }

  search(obj);
  return paths;
}
